import { YesNoEnum } from '../HouseholdOutgoings/types';

export const partnerAddressHistoryQuestions: Record<string, any> = {
  sameAddress: {
    labelKey: 'applicationForm.PARTNER_ADDRESS_HISTORY.sameAddress',
    options: [
      { labelKey: 'common.yes', value: YesNoEnum.YES },
      { labelKey: 'common.no', value: YesNoEnum.NO },
    ],
  },
};
